/**
 * Convert HTML snippets to normalized plain text
 * Used to match highlighted AI suggestions against editor content
 */
export const htmlToPlainText = (html: string | null | undefined): string => {
  if (!html) {
    return "";
  }

  let textContent = html;

  if (typeof window !== "undefined" && window.document) {
    const container = window.document.createElement("div");
    container.innerHTML = html;
    textContent = container.textContent || container.innerText || "";
  } else {
    // Fallback for non-browser environments
    textContent = html.replace(/<[^>]*>/g, " ");
  }

  return textContent
    .replace(/&nbsp;/gi, " ")
    .replace(/\u00a0/g, " ")
    .replace(/[\u2018\u2019]/g, "'")
    .replace(/[\u201C\u201D]/g, '"')
    .replace(/[\u2013\u2014]/g, "-")
    .replace(/\s+/g, " ")
    .trim();
};
